import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()(() => ({
    notificationText: {
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        fontSize: '14px'
    },
    collapsed: {
        WebkitLineClamp: 2
    },
    expanded: {
        WebkitLineClamp: 'unset'
    }
}))